<template>
  <div style="height: 100%;">
    <div style="width: 960px">
      <div>
      <el-form class="search-form" inline size="small">
        <el-form-item>
          <el-select clearable filterable v-model="form.searchCategory" size="small" style="width:180px;" placeholder="分组名称" @change="changeCategory">
            <el-option v-for="item in category_option" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select clearable filterable v-model="form.searchTitle" size="small" style="width:180px;" placeholder="话术标题">
            <el-option v-for="item in title_option" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            class="selectInput"
            style="width:190px"
            size="small"
            v-model="form.searchText"
            placeholder="话术内容关键字"
          >
            <svg slot="suffix" class="icon" aria-hidden="true" @click="getData(1)">
              <use xlink:href="#iconsearchicon" />
            </svg>
          </el-input>
        </el-form-item>
        <div style="position:absolute;right:20px;">
          <el-form-item><el-button type="info" @click="showAddDialog()">新增</el-button></el-form-item>
          <el-form-item><el-button type="info" @click="batchDelete()">批量删除</el-button></el-form-item>
          <el-form-item><el-button type="info" @click="synchQRmsg = true, skillGroupIds = []">同步</el-button></el-form-item>
          <el-form-item><el-button type="primary" @click="addExcel = true, cleanAll = false">导入</el-button></el-form-item>
          <el-form-item style="margin-right: 0"><el-button type="primary" @click="exportExcel()">导出</el-button></el-form-item>
        </div>
      </el-form>
      </div>
      <el-table ref="quickReplys" :data="quickReplys" style="width: 100%">
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="category" label="分组名称" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="title" label="话术标题" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="message" label="话术内容"></el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="修改" placement="bottom">
              <el-button type="text" size="mini" @click="showEditDialog(scope.row)">
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#icontable-bianji" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除" placement="bottom">
              <el-button type="text" size="mini" @click="deleteQRById(scope.row.id)">
                <svg class="icon icon-delete" aria-hidden="true">
                  <use xlink:href="#icontable-delete" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="上移" placement="bottom">
              <el-button size="mini" :disabled="scope.$index===0" @click="moveUp(scope.$index, scope.row)" style="padding-left: 5px;padding-right: 5px;">
                <i class="el-icon-arrow-up"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="下移" placement="bottom">
              <el-button size="mini" :disabled="scope.$index===(quickReplys.length-1)" @click="moveDown(scope.$index, scope.row)" style="padding-left: 5px;padding-right: 5px;">
                <i class="el-icon-arrow-down"></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page text-right">
        <el-pagination style="margin:20px 0 0;"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="form.pageSize"
          :current-page="form.pageNum"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <el-dialog
        :title="dialogTitle"
        width="930px"
        :destroy-on-close="true"
        :visible.sync="addQRmsg"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-row>
          <div>
            <el-form :inline="true">
              <el-form-item label="分组名称:">
                <el-input
                  v-model="uform.category"
                  maxlength="20"
                  placeholder="输入分组名称，最大长度20个字"
                  style="width:807px;"
                ></el-input>
              </el-form-item>
              <el-form-item label="话术标题:">
                <el-input
                  v-model="uform.title"
                  maxlength="50"
                  placeholder="输入话术标题，最大长度50个字"
                  style="width:807px;"
                ></el-input>
              </el-form-item>
              <el-form-item label="话术内容:">
                <el-input
                  type="textarea"
                  v-model="uform.message"
                  maxlength="500"
                  :rows="8"
                  placeholder="消息最大长度500个字"
                  style="width:807px;"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <el-row type="flex" justify="center">
            <el-button size="medium" @click="cancelAdd()">取 消</el-button>
            <el-button size="medium" type="primary" @click="addQRmsgFn()">确 定</el-button>
          </el-row>
        </el-row>
      </el-dialog>
      <el-dialog
        title="文件上传"
        width="480px"
        center
        style="padding-top:100px;"
        :destroy-on-close="true"
        :visible.sync="addExcel"
        append-to-body
        :close-on-click-modal="false"
        @close="handleClose"
      >
        <el-row>
          <el-upload
            class="upload-demo"
            :action="fileUploadAction + '&cleanAll=' + cleanAll"
            :headers="headers"
            :multiple=false
            accept=".xlsx,.xls"
            :limit=2
            ref="uploadExcel"
            :file-list="fileList"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传</el-button>
            <a href="./home/files/quickReplyTemplate.xlsx"><el-button style="margin-left: 10px;" size="small" type="success">模板下载</el-button></a>
            <div style="padding-top:15px;padding-bottom:10px;"><el-checkbox v-model="cleanAll">上传时清空已有的快捷回复<span style="color:red;">( 请谨慎选择！)</span></el-checkbox></div>
            <div slot="tip" class="el-upload__tip">只能上传单个excel文件，且不超过5M！</div>
          </el-upload>
        </el-row>
      </el-dialog>
      <el-dialog
        title="同步"
        width="380px"
        :destroy-on-close="true"
        :visible.sync="synchQRmsg"
        append-to-body
        style="padding-top:100px;"
        :close-on-click-modal="false"
      >
        <el-row>
          <div>
            <el-form class="form" inline size="small">
              <el-form-item label="请选择技能组：">
                <el-select filterable multiple collapse-tags v-model="skillGroupIds" size="small" placeholder="" style="width:220px;">
                  <el-option v-for="item in skillsGroup_options" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <el-row type="flex" justify="center">
            <el-button size="medium" @click="skillGroupIds=[];synchQRmsg=false;">取 消</el-button>
            <el-button size="medium" type="primary" @click="submitSynch()">确 定</el-button>
          </el-row>
        </el-row>
      </el-dialog>
      <Progress progressTitle="更新进度" :progressTaskId="progressTaskId" ref="updateProgress" :progressFinish="updateFinish" :showClose="false"></Progress>
    </div>
</div>
</template>
<script>
import { updateQuickReplys, getSkillGroupQuickReplys, addQuickReply, exportQuickReply, deleteQRByIds, synchQRMsg } from '@/api/skill'
import Progress from '@/views/components/progress/Progress.vue'
export default {
  components: { Progress },
  data() {
    return {
      form: {
        pageSize: 10,
        pageNum: 1,
        searchText: '',
        searchCategory: '',
        searchTitle: ''
      },
      quickReplys: [],
      category_option: [],
      title_option: [],
      // 分组名称/话术标题原始数据
      category_title_value: [],
      total: 0,
      // 新增/编辑快捷回复信息
      dialogTitle: '',
      addQRmsg: false,
      uform: {
        message: '',
        category: '',
        title: '',
        id: '',
        createTime: '',
        num: 0
      },
      // 上传快捷列表
      addExcel: false,
      fileList: [],
      headers: { Authorization: localStorage.getItem('Authorization'), 'X-TENANT-ID': localStorage.getItem('X-TENANT-ID') },
      fileUploadAction: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/quickReply/upload/file?skillGroupId=' + this.skillId,
      cleanAll: false,
      synchQRmsg: false,
      skillGroupIds: [],
      progressTaskId: 'synchQRmessages'
    }
  },
  props: {
    skillId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.getData(this.form.pageNum)
  },
  computed: {
    skillsGroup_options() {
      return this.$store.state.user.skillGroupList
    }
  },
  methods: {
    getData(_pageNum) {
      if (!this.skillId) {
        this.$message.error('技能组id不能为空!')
        return false
      }
      this.form.pageNum = _pageNum
      const params = {
        skillGroupId: this.skillId,
        pageNum: _pageNum,
        pageSize: this.form.pageSize,
        searchText: this.form.searchText,
        searchCategory: this.form.searchCategory,
        searchTitle: this.form.searchTitle
      }
      getSkillGroupQuickReplys(params).then(res => {
        if (res.code === 2000) {
          this.quickReplys = res.data.data
          this.category_title_value = res.data.categorys
          this.category_option = [...new Set(res.data.categorys.map(ca => { return ca.category }))]
          this.title_option = [...new Set(res.data.categorys.map(ca => { return ca.title }))]
          this.total = res.data.filterCount
          this.$emit('updateQuickReplyCount', res.data.totalCount)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleCurrentChange(_pageNum) {
      this.getData(_pageNum)
    },
    // 展示新增框
    showAddDialog() {
      this.addQRmsg = true
      this.uform.message = ''
      this.uform.title = ''
      this.uform.category = ''
      this.uform.id = ''
      this.uform.createTime = ''
      this.uform.num = 0
      this.dialogTitle = '添加快捷回复消息'
    },
    // 展示编辑框
    showEditDialog(row) {
      this.addQRmsg = true
      this.uform = { ...row }
      this.dialogTitle = '编辑快捷回复消息'
    },
    // 新增/编辑快捷回复内容
    addQRmsgFn() {
      if (this.uform.message === '' || this.uform.message.split(' ').splice('').length === 0 ||
        this.uform.category === '' || this.uform.category.split(' ').splice('').length === 0 ||
        this.uform.title === '' || this.uform.title.split(' ').splice('').length === 0) {
        this.$message.warning('分组名称,话术标题或话术内容不能为空')
        return false
      }
      if (this.uform.category.indexOf('【') > -1 || this.uform.category.indexOf('】') > -1) {
        this.$message.warning('分组名称不能包含中文符号【】')
        return false
      }
      if (this.uform.title.indexOf('【') > -1 || this.uform.title.indexOf('】') > -1) {
        this.$message.warning('话术标题不能包含中文符号【】')
        return false
      }
      if (this.dialogTitle === '添加快捷回复消息') {
        if (this.quickReplys.map(qr => { return qr.message }).indexOf(this.uform.message) > -1) {
          this.$message.warning('话术内容已存在，不必新增！')
          return false
        }
        addQuickReply({ quickReplys: [this.uform], skillGroupId: this.skillId }).then(res => {
          if (res.code === 2000) {
            this.$message.success('数据新增成功!')
            this.addQRmsg = false
            this.cancelAdd()
            this.getData(1)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        updateQuickReplys({ quickReplys: [this.uform], skillGroupId: this.skillId }).then(res => {
          if (res.code === 2000) {
            this.$message.success('数据更新成功!')
            this.addQRmsg = false
            this.cancelAdd()
            this.getData(1)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    cancelAdd() {
      this.addQRmsg = false
      this.uform.message = ''
      this.uform.category = ''
      this.uform.title = ''
      this.uform.id = ''
      this.uform.createTime = ''
      this.uform.num = 0
    },
    // 单条删除
    deleteQRById(id) {
      this.$confirm('是否删除此话术？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        deleteQRByIds([id])
          .then(res => {
            if (res.code === 2000) {
              this.$message.success('数据删除成功')
              this.getData(0)
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.$message.error(err)
          })
      })
    },
    // 批量删除
    batchDelete() {
      // 判断是否有选择数据
      const selection = this.$refs.quickReplys.selection
      if (!selection || selection.length === 0) {
        this.$message.error('请勾选数据')
        return
      }
      this.$confirm('是否批量删除话术？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      })
        .then(() => {
          deleteQRByIds(selection.map(s => { return s.id }))
            .then(res => {
              if (res.code === 2000) {
                this.$message.success('数据删除成功')
                this.getData(1)
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(err => {
              this.$message.error(err)
            })
        })
        .catch(() => {})
    },
    exportExcel() {
      const params = {
        skillGroupId: this.skillId
      }
      exportQuickReply(params).then(res => {
        const blob = new Blob([res])
        const fileName = '技能组快捷回复语_' + Date.now() + '.xlsx'
        if ('download' in document.createElement('a')) { // 非IE下载
          const alink = document.createElement('a')
          alink.download = fileName
          alink.style.display = 'none'
          alink.href = URL.createObjectURL(blob) // 这里是将文件流转化为一个文件地址
          document.body.appendChild(alink)
          alink.click()
          URL.revokeObjectURL(alink.href) // 释放URL 对象
          document.body.removeChild(alink)
        } else { // IE10+下载
          // 其他浏览器
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    // 当重新选择文件时，替换已选择的文件，从而实现变更要上传的文件，保证上传列表中只有一个文件；limit要大于2，否则只会触发onExceed，而不执行onChange
    handleChange(files, fileList) {
      this.fileList = [files]
    },
    // 文件上传检查
    beforeUpload (file) {
      if (file.size > 1024 * 1024 * 5) {
        this.$message.warning('上传的文件大于5Mb，请重新上传！')
        this.fileList = []
        return false
      }
      return true
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleSuccess (response, file, fileList) {
      if (response.code === 2000) {
        this.getData(1)
        this.$message.success('文件上传成功!')
        this.$refs.uploadExcel.uploadFiles = []
        this.addExcel = false
      } else {
        this.$message.error(response.msg)
      }
    },
    handleError (err, file, fileList) {
      this.$message.error(err)
    },
    // 上传
    submitUpload () {
      if (this.fileList.length === 0) {
        this.$message.warning('请选择文件')
        return false
      }
      this.$refs.uploadExcel.submit()
    },
    // 关闭导入展示弹框，清除文件列表，表单校验设置为null
    handleClose() {
      this.addExcel = false
      this.$refs.uploadExcel.uploadFiles = []
      this.fileList = []
    },
    moveUp(index, row) {
      const that = this
      if (index > 0) {
        const upQR = that.quickReplys[index - 1] // 要被替换的位置的数据
        const copyUpQR = { ...upQR }
        const copyRow = { ...row }
        // 交换数据位置及内容
        upQR.createTime = copyRow.createTime
        upQR.num = copyRow.num
        that.quickReplys.splice(index - 1, 1)
        that.quickReplys[index - 1].createTime = copyUpQR.createTime
        that.quickReplys[index - 1].num = copyUpQR.num
        that.quickReplys.splice(index, 0, upQR)
        // 更新交换的2条数据
        const updateQRs = []
        updateQRs.push(upQR)
        updateQRs.push(that.quickReplys[index - 1])
        updateQuickReplys({ quickReplys: updateQRs, skillGroupId: this.skillId }).then(res => {
          if (res.code === 2000) {
            this.$message.success('数据更新成功!')
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.warning('已经是第一条，不可上移')
      }
    },
    moveDown(index, row) {
      const that = this
      if (index + 1 === that.quickReplys.length) {
        this.$message.warning('已经是最后一条，不可下移')
      } else {
        const downQR = that.quickReplys[index + 1]
        const copydownQR = { ...downQR }
        const copyRow = { ...row }
        // 交换数据位置及内容
        downQR.createTime = copyRow.createTime
        downQR.num = copyRow.num
        downQR.execSequence = index
        that.quickReplys.splice(index + 1, 1)
        that.quickReplys.splice(index, 0, downQR)
        that.quickReplys[index + 1].createTime = copydownQR.createTime
        that.quickReplys[index + 1].num = copydownQR.num
        // 更新交换的2条数据
        const updateQRs = []
        updateQRs.push(downQR)
        updateQRs.push(that.quickReplys[index + 1])
        updateQuickReplys({ quickReplys: updateQRs, skillGroupId: this.skillId }).then(res => {
          if (res.code === 2000) {
            this.$message.success('数据更新成功!')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 话术标题随着分组名称变换，反之，不变换
    changeCategory(item) {
      if (item) {
        this.title_option = [...new Set(this.category_title_value.filter(ca => ca.category === item).map(ca => { return ca.title }))]
      } else {
        this.title_option = [...new Set(this.category_title_value.map(ca => { return ca.title }))]
      }
    },
    submitSynch() {
      if (this.skillGroupIds.length === 0) {
        this.$message.warning('请选择至少一个技能组来进行同步！')
        return false
      }
      if (this.skillGroupIds.length === 1 && this.skillGroupIds[0] === this.skillId) {
        this.$message.warning('请选择至少一个不同技能组来进行同步！')
        return false
      }
      const params = {
        skillGroupId: this.skillId,
        progressTaskId: this.progressTaskId
      }
      synchQRMsg([...this.skillGroupIds], params).then(res => {
        if (res.code === 2000) {
          this.$refs.updateProgress.startProgress()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    updateFinish(data) {
      if (data.finished === true && data.success === true) {
        this.synchQRmsg = false
        this.$message.success('数据同步成功!')
      } else {
        this.$message.error('数据同步失败!')
      }
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  margin: 0;
  padding: 0;
}
.el-input{
  width: 100%;
}
.search-form.el-form {
  display: flex;
  justify-content: flex-start;
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
.selectInput {
  line-height: inherit;
}
.el-form-item {
  position: relative;
  ::v-deep .el-form-item__label{height:40px;line-height:40px !important;}
  .input-border {
    ::v-deep .el-input__inner {
      padding-left: 5px;
      padding-top: 5px;
      padding-bottom: 5px;
      border-radius: 5px;
      border-bottom: 1px solid #DCDFE6;
      height:35px;
      line-height:35px;
      font-size:14px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      word-wrap: break-word;
      word-break: break-all;
      &:focus {
      border-bottom: 1px solid #409EFF;
      }
    }
  }
  .icon-delete {
    color: #f66f6a;
  }
}

.table-page {
  margin: 20px 0;
}

.el-dialog .el-dialog__body .el-button + .el-button {
  margin-left: 10px;
}

</style>
<style lang="scss">
.el-textarea__inner {
  resize: none !important;
}
</style>
